import { IsBoolean, IsNumber } from 'class-validator';
import { Transform } from 'class-transformer';

export abstract class PageResponseVm<T, O> {
  @IsBoolean()
  hasNext: boolean;

  @IsNumber()
  @Transform(({ value }) => +value)
  totalItems: number;

  @IsNumber()
  @Transform(({ value }) => +value)
  nextLimit: number;

  abstract nextOffset: O | null;

  abstract objects: T[];
}
